import * as angular from 'angular';

export default function BenchmarksBellCurveCtrl($compile, $scope, $element) {
  'ngInject';

  angular.extend($scope, {
    benchmarksGraph: {
      data: {
        benchmarks: {
          all: {},
          similar: {}
        }
      },
      config: {}
    },
    checkIdea: 'idea works',
    setScopeVar: function (item, val) {
      this[item] = val;
      return this;
    },
    extendScope: function (config) {
      angular.extend(this, config);
      // console.log('SUMMARY GRAPH SCOPE:');
      // console.log(this);
    },
    update: function () {
      this.$apply();
      this.$broadcast('redraw');
    }
  });

  var subScope = $scope.$new();

  var el = $compile(
    '<div><div benchmarks-graph stuff="benchmarksGraph.data" config="benchmarksGraph.config"></div></div>'
  )(subScope);
  $element.append(el);
}
